import { filterBuilder, BuilderContext } from '@ha/algolia';
import { AlgoliaQuery } from 'ha/services/algolia';
import getGeoBoundaryFilter from './getGeoBoundaryFilter';
import getFilterParams from './getFilterParams';
import {
  ReqParams,
  SearchParams,
  SearchOptions,
  CurrencyEuroRates,
} from './types';
import { SearchAlgoliaListingParams } from '../../types';
import { FacetQueryAttributes } from '../../constants';

const queryFilterBuilder = filterBuilder();

export default (
  reqParams: ReqParams,
  searchParams: SearchParams,
  currencyEuroRates: CurrencyEuroRates,
  context: BuilderContext,
  searchOptions: SearchOptions = {},
): AlgoliaQuery => {
  // to make sure all required attributes are retrieved
  const attributeNames: {
    [key in keyof Required<SearchAlgoliaListingParams>]: true;
  } = {
    id: true,
    internalID: true,
    _geoloc: true,
    advertiserAvatar: true,
    propertyType: true,
    creationDateTS: true,
    dateFrom: true,
    dateTo: true,
    minimumStayMonths: true,
    priceEUR: true,
    utilities: true,
    facility_bedroom_count: true,
    facility_bedroom_furnished: true,
    facility_bedroom_size: true,
    facility_total_size: true,
    facility_registration_possible: true,
    facility_bed: true,
    path: true,
    thumbnailURL: true,
    city: true,
    advertiserId: true,
    street: true,
    photos: true,
    photoCount: true,
    floorPlanCount: true,
    videoCount: true,
    currentOccupancy: true,
    freePlaces: true,
    cPolicy: true,
    contractType: true,
    minPrice: true,
    maxPrice: true,
    priceType: true,
  };

  const geoBoundaryFilter = getGeoBoundaryFilter(reqParams, searchParams);
  const filterParams = getFilterParams(reqParams, currencyEuroRates);
  const filters = queryFilterBuilder(filterParams, context);

  const page = searchOptions.withoutData
    ? undefined
    : reqParams.offset / reqParams.limit;

  const algoliaQuery: AlgoliaQuery = {
    query: '',
    params: {
      distinct: true,
      insideBoundingBox: geoBoundaryFilter,
      facets: searchOptions.withoutFacets
        ? []
        : [
            ...FacetQueryAttributes,
            'isPartner', // used in analytics
          ],
      attributesToHighlight: [],
      attributesToRetrieve: Object.keys(attributeNames),
      hitsPerPage: searchOptions.withoutData ? 0 : reqParams.limit,
      filters,
    },
  };

  if (typeof page !== 'undefined') {
    algoliaQuery.params = { ...algoliaQuery.params, page };
  }

  return algoliaQuery;
};
